import { app } from '../../app';

app.factory('SamlService', SamlService);

/** @ngInject */
function SamlService($resource) {
	
	
    var getSPWebSamlData = $resource('app/rest/loginSAMLWeb/:appKey', {
        SAMLTracker: '@SAMLTracker',
        appKey : '@appKey',
        il: '@il',
        pl: '@pl'
    }, {});//body format: {username, password}	
    
    var getSPWebSamlDataUsb = $resource('app/rest/loginSAMLWeb/usb/:appKey', {
        SAMLTracker: '@SAMLTracker',
        appKey : '@appKey',
        username : '@username',
        authenticationRequests: '@authenticationRequests'
    }, {});

    var getSPSamlData = $resource('app/rest/loginSAML/:appKey', {
        SAMLTracker: '@SAMLTracker',
        appKey : '@appKey',
    }, {});

    var getSamlLoginUrl = $resource('app/rest/loginSAML', {
        applicationId : '@applicationId',
        accountId : '@accountId',
        awsrole : '@awsrole'
    }, {});

    var getIDPSamlLoginUrl = $resource('app/rest/loginSAML/idp/:req/:link', {
        req : '@req',
        link : '@link'
    }, {});

    var getAppAccountFormat = $resource('app/rest/application/logindetails/:appKey', {
        content : '@appKey'
    }, {});

    return {
        getSPSamlData : getSPSamlData,
        getSamlLoginUrl : getSamlLoginUrl,
        getIDPSamlLoginUrl : getIDPSamlLoginUrl,
        getSPWebSamlData : getSPWebSamlData,
        getAppAccountFormat: getAppAccountFormat,
        getSPWebSamlDataUsb : getSPWebSamlDataUsb
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/saml.service.js